import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'checkbox',
    'intro',
    'formContainer',
    'formInputs',
    'singlePageInputs',
  ]

  connect() {
    this.refresh()
  }

  refresh() {
    // Prevent multiple calls to refresh from stacking up and causing
    // performance issues. This could be triggered by a select all action
    // that triggers change events on all dependent checkboxes, for example.
    cancelAnimationFrame(this.refreshAnimationFrame)

    this.refreshAnimationFrame = requestAnimationFrame(() => {
      this.#update()
    })
  }

  get selectedCount() {
    return this.checkboxTargets.filter((checkbox) => checkbox.checked).length
  }

  #show({ intro, form, single }) {
    this.introTarget.classList.toggle('hidden', !intro)
    this.formContainerTarget.classList.toggle('hidden', !form)
    this.formInputsTarget.classList.toggle('hidden', !form)
    this.singlePageInputsTarget.classList.toggle('hidden', !single)
  }

  #update() {
    switch (this.selectedCount) {
      case 0:
        this.#show({
          intro: true,
          form: false,
          single: false,
        })
        break

      case 1:
        this.#show({
          intro: false,
          form: true,
          single: true,
        })
        break

      default:
        this.#show({
          intro: false,
          form: true,
          single: false,
        })
    }
  }
}
